import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, TextField, Typography, Chip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

/**
 * Painel para colar a base de conhecimento da clínica (FAQs, políticas,
 * instruções). O texto é enviado junto com a conversa e vira a fonte
 * oficial de informação da IA. Aceita qualquer formato (ex: conteúdo
 * copiado de uma planilha).
 */
function KnowledgePanel({ value, onChange }) {
  const hasContent = (value || "").trim() !== "";

  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: "1px solid var(--border, #E2E8F0)",
        borderRadius: "12px !important",
        marginBottom: "16px",
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <MenuBookOutlinedIcon style={{ color: "var(--color-blue-main, #5A80FB)" }} fontSize="small" />
          <Typography style={{ fontWeight: 500 }}>Base de conhecimento (teste)</Typography>
          {hasContent ? (
            <Chip label="Ativa" size="small" color="primary" variant="outlined" />
          ) : (
            <Chip label="Vazia" size="small" variant="outlined" />
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: "12px" }}>
          Texto extra apenas para experimentos neste navegador — é somado à base oficial e às
          preferências configuradas em <b>Configurações &gt; Assistente de IA</b>, com prioridade
          em caso de conflito. Cole perguntas e respostas, políticas ou instruções (pode copiar
          direto de uma planilha — a formatação não importa).
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={6}
          maxRows={16}
          placeholder={"Exemplos:\nVocês aceitam convênio? Não atendemos por convênio, mas emitimos recibo e nota fiscal para reembolso.\nHorário de atendimento: segunda a sexta, das 8h às 19h."}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </AccordionDetails>
    </Accordion>
  );
}

export default KnowledgePanel;
